import React, { useState, useEffect } from 'react'
import {
    ItemsGrid,
    PageWrapper,
    Flex,
    H1WithBack,
    GridItem,
} from '../../../styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { Modal } from '../../../components/Modal/Modal'
import { CategoryModal } from '../../../components/Modal/CategoryModal'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../../components/NavBar/NavBar'
import { AppDispatch, RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { clearFoodCategories, deleteFoodCategory, getFoodCategories } from 'features/food/foodSlice'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { setConfirmModal } from 'features/global/globalSlice'

export const FoodCategories = () => {
    const dispatch = useDispatch<AppDispatch>()
    const { data, } = useSelector((store: RootState) => store.food.categories)
    const [modal, setModal] = useState({
        open: false,
        edit: true,
        text: '',
        id: null,
        image: null,
        imageFile: null
    })

    const ToggleEditModal = (text: string, id: number, image: string) => {
        setModal({ open: true, edit: true, text: text, id, image, imageFile: null })
    }

    const ToggleAddModal = () => {
        setModal({ open: true, edit: false, text: '', id: '', image: null, imageFile: null })
    }

    useEffect(() => {
        dispatch(getFoodCategories({ page: 1, limit: 99 }))
        return () => {
            dispatch(clearFoodCategories())
        }
    }, [])

    const removeFoodCategoryRole = (e, id: number) => {
        e.stopPropagation()
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteFoodCategory(id))
                },
                word: 'delete food category',
            }),
        )
    }

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center>
                    <H1WithBack title='Food Categories' arrow />
                    <Button variant='primary' onClick={ToggleAddModal}>
                        Add category
                    </Button>
                </Flex>
                <ItemsGrid columns={3} mt='25px'>
                    {data?.length ? (
                        data.map(({ name, id }) => {
                            return (
                                <GridItem key={id} onClick={() => ToggleEditModal(name, id, null)} >
                                    <p  >
                                        {name}
                                    </p>

                                    <Flex between center onClick={(e) => removeFoodCategoryRole(e, id)}>
                                        <RemoveCircle />
                                    </Flex>
                                </GridItem>
                            )
                        })
                    ) : (
                        <NoItems title='Food Categories' />
                    )}
                </ItemsGrid>
                {modal.open && (
                    <Modal black>
                        <CategoryModal
                            edit={modal.edit}
                            close={setModal}
                            id={modal.id}
                            text={modal.text}
                            image={modal.image}
                            imageFile={modal.imageFile}
                            food={true}
                        />
                    </Modal>
                )}

            </PageWrapper>
        </>
    )
}
